<script setup>
import { onMounted, ref, watch } from 'vue'
import { post } from '@/api/Services'
import HowItWorksMain from '../components/HowItWorksMain.vue'

const processData = ref([])

const photo = ref('')

const header = ref('')
const header_subtext = ref('')
const section_header = ref('')
const section_subtext = ref('')
const mediaURL = ref(process.env.VUE_APP_MEDIA_URL)
const tabHeader = ref('')
const tabSubheader = ref('')
const tabImg = ref('')
const tabHeader2 = ref('')
const tabSubheader2 = ref('')
const tabImg2 = ref('')
const tabHeader3 = ref('')
const tabSubheader3 = ref('')
const tabImg3 = ref('')
const heroImg = ref('')
const heroHeader = ref('')
const heroParagraph = ref('')
const clientStats = ref([])
const heroBtnText = ref('')

const activeIndex = ref(0)

watch(activeIndex, () => {
  cms()
})

const cms = async () => {
  // Generate parameters dynamically based on `activeIndex`
  const parameters = [
    { parameter_name: 'piv_page_path', parameter_value: '/how-it-works' },
    {
      parameter_name: 'piv_tag_group',
      parameter_value: (() => {
        switch (activeIndex.value) {
          case 0:
            return 'companies'
          case 1:
            return 'recruiters'
          case 2:
            return 'candidates'
          default:
            return ''
        }
      })(),
    },
  ]

  try {
    // Perform the API call
    const data = await post('/Commons/Executer', {
      sqlId: 76,
      parameters: JSON.stringify(parameters),
    })
    data.map((each) => {
      switch (each.tag) {
        case 'header':
          header.value = each.html_content
          break
        case 'header_subtext':
          header_subtext.value = each.html_content
          break
        case 'section_header':
          section_header.value = each.html_content
          break
        case 'section_subtext':
          section_subtext.value = each.html_content
          break
        case 'section_list':
          processData.value = JSON.parse(each.list_content).sort(
            (a, b) => a.order_id - b.order_id
          )
          break
        case 'section_img':
          photo.value = `${mediaURL.value}${each.file_path}`
          break
        case 'tab_header':
          tabHeader.value = each.html_content
          break
        case 'tab_subheader':
          tabSubheader.value = each.html_content
          break
        case 'tab_img':
          tabImg.value = `${mediaURL.value}${each.file_path}`
          break
        case 'tab_header2':
          tabHeader2.value = each.html_content
          break
        case 'tab_subheader2':
          tabSubheader2.value = each.html_content
          break
        case 'tab_img2':
          tabImg2.value = `${mediaURL.value}${each.file_path}`
          break
        case 'tab_header3':
          tabHeader3.value = each.html_content
          break
        case 'tab_subheader3':
          tabSubheader3.value = each.html_content
          break
        case 'tab_img3':
          tabImg3.value = `${mediaURL.value}${each.file_path}`
          break
        case 'hero_img':
          heroImg.value = `${each.file_path}`
          break
        case 'hero_header':
          heroHeader.value = each.html_content
          break
        case 'hero_paragraph':
          heroParagraph.value = each.html_content
          break
        case 'hero_button':
          heroBtnText.value = each.html_content
          break
        case 'client_list': {
          const parsedData = JSON.parse(each.list_content)
          parsedData.sort((a, b) => a.order_id - b.order_id)
          clientStats.value = parsedData
          break
        }
      }
    })
  } catch (error) {
    // Handle errors gracefully
    console.error('Error fetching CMS data:', error)
  }
}

onMounted(() => {
  cms()
})
</script>

<template>
  <div class="">
    <h1 class="title mb-3">{{ header }}</h1>
    <TabView
      class="tabview-custom"
      :activeIndex="activeIndex"
      @tab-change="activeIndex = $event.index"
    >
      <TabPanel>
        <template #header>
          <div
            class="d-flex gap-6 align-items-center px-4 py-3 justify-content-center w-100"
          >
            <div class="card-icon">
              <img loading="lazy" :src="`${tabImg}`" alt="" />
            </div>
            <div class="card-title">
              <h4 class="mb-1">{{ tabHeader }}</h4>
              <p>{{ tabSubheader }}</p>
            </div>
          </div>
        </template>
        <HowItWorksMain
          :section_header="section_header"
          :section_subtext="section_subtext"
          :photo="photo"
          :process="processData"
          :hero_img="heroImg"
          :hero_header="heroHeader"
          :hero_paragraph="heroParagraph"
          :hero_button="heroBtnText"
          :client_stats="clientStats"
        />
      </TabPanel>
      <TabPanel>
        <template #header>
          <div
            class="d-flex gap-6 align-items-center px-4 py-3 justify-content-center w-100"
          >
            <div class="card-icon">
              <img loading="lazy" :src="`${tabImg2}`" alt="" />
            </div>
            <div class="card-title">
              <h4 class="mb-1">{{ tabHeader2 }}</h4>
              <p>{{ tabSubheader2 }}</p>
            </div>
          </div>
        </template>
        <HowItWorksMain
          :section_header="section_header"
          :section_subtext="section_subtext"
          :photo="photo"
          :process="processData"
          :hero_img="heroImg"
          :hero_header="heroHeader"
          :hero_paragraph="heroParagraph"
          :hero_button="heroBtnText"
          :client_stats="clientStats"
        />
      </TabPanel>
      <TabPanel>
        <template #header>
          <div
            class="d-flex gap-6 align-items-center px-4 py-3 justify-content-center w-100"
          >
            <div class="card-icon">
              <img loading="lazy" :src="`${tabImg3}`" alt="" />
            </div>
            <div class="card-title">
              <h4 class="mb-1">{{ tabHeader3 }}</h4>
              <p>{{ tabSubheader3 }}</p>
            </div>
          </div>
        </template>
        <HowItWorksMain
          :section_header="section_header"
          :section_subtext="section_subtext"
          :photo="photo"
          :process="processData"
          :hero_img="heroImg"
          :hero_header="heroHeader"
          :hero_paragraph="heroParagraph"
          :hero_button="heroBtnText"
          :client_stats="clientStats"
        />
      </TabPanel>
    </TabView>
  </div>
</template>
<style lang="scss" scoped>
.title {
  font-size: 50px;
  color: #444444;
  font-weight: 700;
  text-align: center;
}
.card-title {
  margin: 0;
  h4 {
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0.01em;
  }
  p {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.01em;
  }
}
.card-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
::v-deep(.p-card-body) {
  padding: 0;
}
::v-deep(.p-card-content) {
  padding: 0;
}
::v-deep(.p-tabview) {
  .p-tabview-panels {
    padding: 0 !important;
  }
  .p-tabview-nav-container {
    max-width: 1240px;
    margin: 0 auto;
    padding-right: 15px;
    padding-left: 15px;
  }
}
::v-deep(.p-tabview-header.p-highlight) {
  .p-tabview-nav-link {
    padding: 0;
    border-radius: 20px !important;
    color: #fff !important;
    background-color: #fc6c2a !important;
    transition: all 300ms;
    box-shadow: 0px 5px 14px 0px rgba(8, 15, 52, 0.04);

    &:hover {
      color: #232323 !important;
      background-color: #ffebcc !important;
    }
    .card-icon {
      background-color: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
  }
}
::v-deep(.p-tabview-header) {
  .p-tabview-nav-link {
    text-decoration: none !important;
    border-radius: 20px !important;
    color: #232323 !important;
    background-color: #fff !important;
    padding: 0 !important;
    transition: all 300ms;
    box-shadow: 0px 5px 14px 0px rgba(8, 15, 52, 0.04);

    &:hover {
      color: #232323 !important;
      background-color: #ffebcc !important;
    }
  }
}
::v-deep(.p-tabview-ink-bar) {
  display: none !important;
}
::v-deep(.p-tabview-nav) {
  display: grid;
  grid-template-columns: repeat(3, 381px);
  gap: 18px;
  border: 0;
  padding: 5px 0;
}
</style>
